export default __webpack_public_path__ + "static/fabricio-dd7c58ca51e54aba868569abc58cc1b6.png";